module.exports = __webpack_public_path__ + "img/question-circle.cee4dc2c.svg";